"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from "react";
import Image from "next/image";
import { mediaUrl } from "@/lib/config/app";
import PromoLabelChips from "@/components/product/PromoLabelChips";
import ProductLabelChips from "@/components/product/ProductLabelChips";
export default function ProductGallery(t0) {
  const $ = _c(17);
  const {
    product,
    selectedVariant,
    showThumbs: t1
  } = t0;
  const showThumbs = t1 === undefined ? true : t1;
  let list;
  if ($[0] !== product) {
    const seen = new Set();
    list = [];
    if (product?.featured_image) {
      list.push({
        src: product.featured_image,
        label: product?.title || "Product Image"
      });
      seen.add(product.featured_image);
    }
    (product?.variants || []).forEach(variant => {
      const src = variant?.variant_image;
      if (!src || seen.has(src)) {
        return;
      }
      seen.add(src);
      const optionLabel = Object.values(variant?.option_values || {}).filter(Boolean).join(" / ");
      list.push({
        src,
        label: optionLabel ? ` ${optionLabel} ${product?.title}` : product?.title || "Product Image"
      });
    });
    $[0] = product;
    $[1] = list;
  } else {
    list = $[1];
  }
  const images = list;
  const [manualImage, setManualImage] = useState(null);
  const activeImage = manualImage || selectedVariant?.variant_image || product?.featured_image;
  const activeLabel = images.find(img => img.src === activeImage)?.label || product?.title;
  const t2 = `${mediaUrl}${activeImage}`;
  let t3;
  if ($[2] !== activeLabel || $[3] !== t2) {
    t3 = <Image src={t2} fill={true} priority={true} loading="eager" sizes="(max-width: 768px) 100vw, 50vw" alt={activeLabel} className="object-contain" />;
    $[2] = activeLabel;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = product?.labels;
  let t5;
  if ($[5] !== t4) {
    t5 = <ProductLabelChips labels={t4} />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <div className="relative aspect-square overflow-hidden rounded bg-white shadow">{t3}{t5}</div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== activeImage || $[11] !== images || $[12] !== showThumbs) {
    t7 = showThumbs && <div className="flex gap-2 overflow-x-auto my-3 pb-3">{images.map((image, i) => {
        const isActive = activeImage === image.src;
        return <div onClick={() => setManualImage(image.src)} key={i} title={image.label} className={`cursor-pointer border relative aspect-square w-20 h-20 lg:w-25 lg:h-25 shadow rounded bg-white ${isActive ? "border-blue-800" : "border-gray-100"}`}><Image src={`${mediaUrl}${image.src}`} fill={true} sizes="(max-width: 768px) 15vw, 16vw" className="rounded" alt={image.label} /></div>;
      })}</div>;
    $[10] = activeImage;
    $[11] = images;
    $[12] = showThumbs;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <div className="col-span-12 lg:col-span-6">{t6}{t7}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}